import axios from 'axios';

export default {
  new(projectId, body) {
    const data = { project_id: projectId, body };
    return axios.post('/comments', data);
  },
  userComments(userId, succ) {
    axios.get(`/comments/user/${userId}`).then((response) => {
      succ(response.data);
    });
  },
  projectComments(projectId, succ) {
    axios.get(`/comments/project/${projectId}`).then((response) => {
      succ(response.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/comments.js